import React from 'react';
import { MenuItem, Select, FormControl, InputLabel, ListSubheader } from '@material-ui/core/';

export class SelectModelType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modelId: props.modelId
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modelId !== this.props.modelId) {
            this.setState({
                modelId: this.props.modelId
            });
        }
    }

    render() {
        const { appContext: { stores: { DataTypesStore }}} = this.props;
        const models = DataTypesStore.getModels().filter((k) => !this.props.category || k.category === this.props.category);
        const items = models.sort((a,b) => {
            // if we are showing all categories of models, then sort by category first, then by name 2nd..
            if (! this.props.category ) {
                let cat = a.category.localeCompare( b.category );
                if ( cat !== 0 ) {
                    return cat;
                }
            }
            return a.name.localeCompare( b.name) 
        }).reduce((p,c) => {
            if (! this.props.category ) {
                if ( p.items.length === 0 || p.category !== c.category) {
                    p.category = c.category;
                    p.items.push(<ListSubheader key={p.items.length}>Category {c.category}</ListSubheader>)
                }
            }
            p.items.push(<MenuItem key={p.items.length} value={c.modelId}>{`${c.name} (${c.modelId})`}</MenuItem>);
            return p;
        }, { category: '', items: [] }).items;

        return <FormControl style={this.props.style || { margin: 5, width: 300}}>
            <InputLabel>{this.props.label || 'Select Model'}</InputLabel>
            <Select value={this.state.modelId} onChange={(e) => {
                this.setState({modelId: e.target.value}, () => {
                    if (typeof this.props.onChange === 'function') {
                        this.props.onChange(e.target.value, models.find((k) => k.modelId === e.target.value));
                    }
                })
            }}>
                {items}
            </Select>
        </FormControl>
    }
}

export default SelectModelType;

